module.exports = __webpack_public_path__ + "static/media/rc_china.5582eb71.png";